import {
  Component,
  Event,
  EventEmitter,
  forceUpdate,
  getAssetPath,
  h,
  Host,
  Prop,
  State,
} from '@stencil/core';

import wcShared from '@web-components/shared';

import helpdeskCommon from '../../../../../utils/HelpdeskCommon.class';
import { InitStore } from '../../../../../utils/Stores/init-store';
import { SectionStore } from '../../../../../utils/Stores/section-store';
import { Store } from '../../../../../utils/Stores/store';

@Component({
  tag: 'contact-mail-jelastic-module',
  styleUrl: 'contact-mail-jelastic-module.scss',
  shadow: true,
})
export class ModuleContactMailJelastic {
  private dataFiles: File[];
  private countFile = 0;
  private body: FormData = new FormData();
  private inputFile: HTMLInputElement;

  @State() dragOverFiles = false;
  @State() files: File[] = [];
  @State() arrayError = [];
  @State() sendButton = false;
  @State() checkEmptyField = false;
  @State() loadingSending = false;
  @State() form: IWCFormJelastic = {
    on_production: null,
    interrupted: null,
    impact: null,
    jelastic_environment: null,
    application_url: null,
    error_message: null,
    documentation_consult: null,
    how_to_reproduce: null,
    solutions_tried: null,
    service_slug: 'jelastic',
    contact_type: 'tech',
    lang: wcShared?.store?.utils?.getLang(),
    conversation_uuid: Store?.get('channel_id'),
    priority: null,
    email: Boolean(InitStore?.get('init')?.user?.email)
      ? InitStore?.get('init')?.user?.email
      : null,
    user_agent: navigator.userAgent,
    current_url: window.location.href,
  };
  @State() urlDocumentation = '';

  @Prop() readonly reload: boolean;
  @Prop() readonly jelasticEnv: string[];

  @Event() sectionChangeEvent: EventEmitter<IWCContextClose[]>;

  componentWillLoad() {
    Store?.set('visibilityModal', true);
  }
  componentDidLoad() {
    // POST Statistic
    wcShared?.httpCall('PUT', '/api/components/chatbot/contact-type', { contact_type: 'mail' });
  }

  private reloadApp() {
    forceUpdate(this);
  }

  private addFile(event) {
    event.preventDefault();
    this.dragOverFiles = false;
    this.inputFile.click();
  }

  private formatFiles(e) {
    e.preventDefault();
    this.dataFiles = e.dataTransfer || e.target.files;
    this.dataFiles = this.dataFiles['files'] || this.dataFiles;

    Object.keys(this.dataFiles).forEach((id) => {
      if (this.dataFiles[id].size <= 50000000) {
        const exist = this.files.find(
          (item) => item.name === this.dataFiles[id].name && item.size === this.dataFiles[id].size,
        );
        if (!Boolean(exist)) {
          this.countFile++;
          this.files?.push(this.dataFiles[id]);
        }
      } else {
        this.arrayError?.push(this.dataFiles[id]);
        setTimeout(() => {
          this.arrayError.shift();
          forceUpdate(this);
        }, 5000);
      }
    });

    this.inputFile.value = '';

    this.reloadApp();
  }

  private checkFields() {
    const result = Object.keys(this.form).every((item) => {
      return this.form[item] !== null;
    });
    return result;
  }

  private handleErrors(response) {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response.json();
  }

  private send() {
    if (!this.checkFields()) {
      return;
    }

    this.loadingSending = true;
    wcShared?.store?.loaderStart('loadingSending');

    if (this.countFile > 0) {
      this.body.append('number_file', String(this.countFile));
    }

    this.files.forEach((file, index) => {
      this.body.append(`file_${index + 1}`, file);
    });

    Object.keys(this.form).forEach((item) => {
      this.body.append(item, this.form[item]);
    });

    if (!Boolean(InitStore?.get('init')?.user?.id)) {
      this.body.append('g-recaptcha-response', Store?.get('g_recaptcha_response'));
    }

    let url = `/api/components/support/contact?lang=${wcShared?.store?.getLang()}`;
    url += helpdeskCommon.urlFormatFaq();

    wcShared
      ?.httpCall('POST', url, this.body, false, true)
      .then(this.handleErrors)
      .then((res) => {
        Store?.set('contactCode', res?.data?.mask);
        this.sectionChangeEvent.emit(['contact_mail_success']);
        wcShared?.store?.loaderStop('loadingSending').then(() => (this.loadingSending = false));
        Store?.set('visibilityModal', false);
      })
      .catch(() => {
        this.sectionChangeEvent.emit(['contact_mail_error']);
        wcShared?.store?.loaderStop('loadingSending').then(() => (this.loadingSending = false));
        Store?.set('visibilityModal', false);
      });
  }

  private getMimeType(file: File) {
    if (file.type.includes('application/pdf')) {
      return 'pdf';
    } else if (file.type.includes('text/plain')) {
      return 'text';
    } else if (file.type.includes('image/')) {
      return 'image';
    } else {
      return 'default';
    }
  }

  private deleteFile(index: number) {
    this.files.splice(index, 1);
    this.countFile--;
    this.reloadApp();
  }

  private onChanges(type: string, value: boolean | string) {
    switch (type) {
      case 'on_production':
        this.form.on_production = value as boolean;
        if (!Boolean(value)) {
          this.form.impact = 'no_client';
          this.form.interrupted = false;
        } else {
          this.form.impact = null;
          this.form.interrupted = null;
        }
        break;
      default:
        this.form[type] = value;
    }

    this.form.priority =
      this.form?.on_production &&
      this.form?.interrupted &&
      (this.form?.impact === 'some_clients' || this.form?.impact === 'full_clients');
    this.reloadApp();
  }

  private debounceReload(questionId: number, timer = 500) {
    wcShared?.store?.utils.debounce(this.reloadApp.bind(this), null, timer, questionId);
  }

  render() {
    if (this.loadingSending) {
      return <module-loader-component />;
    } else {
      return (
        <Host>
          {/* Modal information */}
          <div class={{ modal: true, hide: !Store?.get('visibilityModal') }}>
            <div class="modal__flag">
              <img
                src={getAssetPath('./../assets/icons/fr-flag.svg')}
                alt={wcShared.translate('Francais')}
              />
              <img
                src={getAssetPath('./../assets/icons/uk-flag.svg')}
                alt={wcShared.translate('Anglais')}
              />
            </div>
            <div class="modal__text">
              {wcShared?.translate(
                'Completer le formulaire de contact suivant en francais ou en anglais de preference si possible.',
              )}
              <br></br>
              <br></br>
              {wcShared?.translate('Merci pour votre comprehension !')}
            </div>
            <div class="modal__action">
              <button onClick={() => Store?.set('visibilityModal', false)}>
                {wcShared?.translate("J'ai compris")}
              </button>
            </div>
          </div>
          <div
            class={{ 'modal-bg': true, hide: !Store?.get('visibilityModal') }}
            onClick={() => Store?.set('visibilityModal', false)}
          ></div>
          <div
            class={{
              'mail-product': true,
              hide:
                !SectionStore?.get('section')?.contact_mail_jelastic ||
                SectionStore?.get('section')?.contact_mail_success ||
                SectionStore?.get('section')?.contact_mail_error,
              'mail-product--full': Store?.get('is_full'),
              'mail-product--scroll': Store?.get('hasScroll') && Store?.get('is_full'),
            }}
          >
            <p class="jelastic__description">
              {wcShared?.translate(
                'Afin de garantir a nos equipes une meilleure prise en charge de votre demande, merci de completer toutes les questions ci-dessous :',
              )}
            </p>

            {/* Question 1 : On Prod */}
            <div
              class={{
                question: true,
                required: this.form?.on_production === null && this.checkEmptyField,
              }}
            >
              <div class="question__title">
                {wcShared?.translate(
                  'Votre site/application est-t-elle actuellement en production ?',
                )}{' '}
                <sup>*</sup>
              </div>
              <div class="question__choice">
                <button
                  class={{ 'question__choice--1': true, selected: this.form.on_production }}
                  onClick={() => {
                    this.onChanges('on_production', true);
                  }}
                >
                  {wcShared?.translate('Oui')}
                </button>
                <button
                  class={{
                    'question__choice--2': true,
                    selected: !this.form.on_production && this.form.on_production !== null,
                  }}
                  onClick={() => {
                    this.onChanges('on_production', false);
                  }}
                >
                  {wcShared?.translate('Non')}
                </button>
              </div>
            </div>
            <span
              class={{
                'required-field': true,
                show: this.form?.on_production === null && this.checkEmptyField,
              }}
            >
              <sup>*</sup>
              {wcShared?.translate('Champ obligatoire')}
            </span>

            {/* Question 2 : Interrupted */}
            <div
              class={{
                question: true,
                hide: !this.form.on_production && this.form.on_production !== null,
                required: this.form?.interrupted === null && this.checkEmptyField,
              }}
            >
              <div class="question__title">
                {wcShared?.translate('Avez-vous identifie une coupure de service ?')} <sup>*</sup>
              </div>
              <div class="question__choice">
                <button
                  class={{ 'question__choice--1': true, selected: this.form.interrupted }}
                  onClick={() => {
                    this.onChanges('interrupted', true);
                  }}
                >
                  {wcShared?.translate('Oui')}
                </button>
                <button
                  class={{
                    'question__choice--2': true,
                    selected: !this.form.interrupted && this.form.interrupted !== null,
                  }}
                  onClick={() => {
                    this.onChanges('interrupted', false);
                  }}
                >
                  {wcShared?.translate('Non')}
                </button>
              </div>
            </div>
            <span
              class={{
                'required-field': true,
                show: this.form?.interrupted === null && this.checkEmptyField,
                hide: this.form?.on_production === false,
              }}
            >
              <sup>*</sup>
              {wcShared?.translate('Champ obligatoire')}
            </span>

            {/* Question 3 : Impact */}
            <div
              class={{
                question: true,
                hide: !this.form.on_production && this.form.on_production !== null,
                required: this.form?.impact === null && this.checkEmptyField,
              }}
            >
              <div class="question__title">
                {wcShared?.translate('La panne impacte-t-elle vos clients ?')} <sup>*</sup>
              </div>
              <div class="question__choice question__choice--vertical">
                <button
                  class={{
                    'question__choice--1': true,
                    selected: this.form.impact === 'full_clients',
                  }}
                  onClick={() => {
                    this.onChanges('impact', 'full_clients');
                  }}
                >
                  {wcShared?.translate('Oui, tous mes clients')}
                </button>
                <button
                  class={{
                    'question__choice--2': true,
                    selected: this.form.impact === 'some_clients',
                  }}
                  onClick={() => {
                    this.onChanges('impact', 'some_clients');
                  }}
                >
                  {wcShared?.translate('Oui, une partie de mes clients')}
                </button>
                <button
                  class={{
                    'question__choice--3': true,
                    selected: this.form.impact === 'no_client',
                  }}
                  onClick={() => {
                    this.onChanges('impact', 'no_client');
                  }}
                >
                  {wcShared?.translate('Non, mes clients ne sont pas impactes')}
                </button>
              </div>
            </div>
            <span
              class={{
                'required-field': true,
                show: this.form?.impact === null && this.checkEmptyField,
                hide: this.form?.on_production === false,
              }}
            >
              <sup>*</sup>
              {wcShared?.translate('Champ obligatoire')}
            </span>

            {/* Question 4 : Jelastic Env */}
            <div
              class={{
                select: true,
                required: this.form?.jelastic_environment === null && this.checkEmptyField,
              }}
            >
              <select
                class={{
                  'select-env': true,
                  'no-margin-bottom': this.form?.jelastic_environment === null,
                }}
                onChange={(event) => {
                  this.form.jelastic_environment = event.target['value'];
                  this.debounceReload(4, 100);
                }}
              >
                <option
                  value=""
                  selected
                  disabled
                  hidden
                >
                  {wcShared?.translate("Selectionner l'environnement impacte")} *
                </option>
                {this.jelasticEnv?.map((service) => {
                  return <option value={service}>{service}</option>;
                })}
              </select>
            </div>
            <span
              class={{
                'required-field': true,
                show: this.form?.jelastic_environment === null && this.checkEmptyField,
              }}
            >
              <sup>*</sup>
              {wcShared?.translate('Champ obligatoire')}
            </span>

            {/* Question 5 : URL Jelastic Env */}
            <div
              class={{
                input: true,
                required: this.form?.application_url === null && this.checkEmptyField,
              }}
            >
              <input
                type="text"
                onKeyPress={(e) => {
                  e.stopPropagation();
                }}
                onKeyDown={(e) => {
                  e.stopPropagation();
                }}
                onKeyUp={(e) => {
                  e.stopPropagation();
                }}
                class={{
                  'input-jelastic-url': true,
                }}
                placeholder={wcShared?.translate('URL de votre site/application si disponible')}
                onInput={(event) => {
                  this.form.application_url = event.target['value'];
                  this.debounceReload(5);
                }}
              />
            </div>
            <span
              class={{
                'required-field': true,
                show: this.form?.application_url === null && this.checkEmptyField,
              }}
            >
              <sup>*</sup>
              {wcShared?.translate('Champ obligatoire')}
            </span>

            {/* Question 6 : Error message */}
            <div
              class={{
                textarea: true,
                required: this.form?.error_message === null && this.checkEmptyField,
              }}
            >
              <textarea
                onKeyPress={(e) => {
                  e.stopPropagation();
                }}
                onKeyDown={(e) => {
                  e.stopPropagation();
                }}
                onKeyUp={(e) => {
                  e.stopPropagation();
                }}
                class={{ 'no-margin-bottom': this.form.error_message === null }}
                onInput={(e) => {
                  this.form.error_message = e.target['value'];
                  this.debounceReload(6);
                }}
                placeholder={wcShared.translate("Quel message d'erreur s'affiche ?") + ' *'}
              ></textarea>
            </div>
            <span
              class={{
                'required-field': true,
                show: this.form?.error_message === null && this.checkEmptyField,
              }}
            >
              <sup>*</sup>
              {wcShared?.translate('Champ obligatoire')}
            </span>

            {/* Question 7 : Read documentation */}
            <div
              class={{
                question: true,
                required: this.form?.documentation_consult === null && this.checkEmptyField,
              }}
            >
              <div class="question__title">
                {wcShared?.translate('Avez-vous consulte une documentation/aide en ligne ?')}{' '}
                <sup>*</sup>
              </div>
              <div class="question__choice">
                <button
                  class={{
                    'question__choice--1': true,
                    selected:
                      this.form.documentation_consult !== 'no' &&
                      this.form.documentation_consult !== null,
                  }}
                  onClick={() => {
                    this.form.documentation_consult = this.urlDocumentation;
                    this.reloadApp();
                  }}
                >
                  {wcShared?.translate('Oui')}
                </button>
                <button
                  class={{
                    'question__choice--2': true,
                    selected: this.form.documentation_consult == 'no',
                  }}
                  onClick={() => {
                    this.form.documentation_consult = 'no';
                    this.reloadApp();
                  }}
                >
                  {wcShared?.translate('Non')}
                </button>
              </div>
            </div>
            <span
              class={{
                'required-field': true,
                show: this.form?.documentation_consult === null && this.checkEmptyField,
              }}
            >
              <sup>*</sup>
              {wcShared?.translate('Champ obligatoire')}
            </span>

            {/* Question 8 : Url documentation */}
            <div
              class={{
                textarea: true,
                hide:
                  this.form.documentation_consult === 'no' ||
                  this.form.documentation_consult === null,
                required: this.form?.documentation_consult === '' && this.checkEmptyField,
              }}
            >
              <textarea
                onKeyPress={(e) => {
                  e.stopPropagation();
                }}
                onKeyDown={(e) => {
                  e.stopPropagation();
                }}
                onKeyUp={(e) => {
                  e.stopPropagation();
                }}
                class={{ 'no-margin-bottom': this.form.documentation_consult === null }}
                onInput={(e) => {
                  this.form.documentation_consult = e.target['value'];
                  this.urlDocumentation = e.target['value'];
                  this.debounceReload(8);
                }}
                placeholder={
                  wcShared.translate(
                    "Renseigner les URL's des pages d'aide que vous avez consultees",
                  ) + ' *'
                }
              ></textarea>
            </div>
            <span
              class={{
                'required-field': true,
                show: this.form?.documentation_consult === '' && this.checkEmptyField,
              }}
            >
              <sup>*</sup>
              {wcShared?.translate('Champ obligatoire')}
            </span>

            {/* Question 9 : How reproduce error */}
            <div
              class={{
                textarea: true,
                required: this.form?.how_to_reproduce === null && this.checkEmptyField,
              }}
            >
              <textarea
                onKeyPress={(e) => {
                  e.stopPropagation();
                }}
                onKeyDown={(e) => {
                  e.stopPropagation();
                }}
                onKeyUp={(e) => {
                  e.stopPropagation();
                }}
                class={{ 'no-margin-bottom': this.form.how_to_reproduce === null }}
                onInput={(e) => {
                  this.form.how_to_reproduce = e.target['value'];
                  this.debounceReload(9);
                }}
                placeholder={
                  wcShared.translate("Quelles manipulations permettent de reproduire l'erreur ?") +
                  ' *'
                }
              ></textarea>
            </div>
            <span
              class={{
                'required-field': true,
                show: this.form?.how_to_reproduce === null && this.checkEmptyField,
              }}
            >
              <sup>*</sup>
              {wcShared?.translate('Champ obligatoire')}
            </span>

            {/* Question 10 : Action to solve */}
            <div
              class={{
                textarea: true,
                required: this.form?.solutions_tried === null && this.checkEmptyField,
              }}
            >
              <textarea
                onKeyPress={(e) => {
                  e.stopPropagation();
                }}
                onKeyDown={(e) => {
                  e.stopPropagation();
                }}
                onKeyUp={(e) => {
                  e.stopPropagation();
                }}
                class={{ 'no-margin-bottom': this.form.solutions_tried === null }}
                onInput={(e) => {
                  this.form.solutions_tried = e.target['value'];
                  this.debounceReload(10);
                }}
                placeholder={
                  wcShared.translate(
                    'Quelles actions avez-vous teste pour tenter de resoudre votre probleme ?',
                  ) + ' *'
                }
              ></textarea>
            </div>
            <span
              class={{
                'required-field': true,
                show: this.form?.solutions_tried === null && this.checkEmptyField,
              }}
            >
              <sup>*</sup>
              {wcShared?.translate('Champ obligatoire')}
            </span>

            {/* Upload Files */}
            <div class={{ 'mail-product-files': true }}>
              <div class="mail-product-files__title">{wcShared?.translate('Fichiers')}</div>
              <div class="mail-product-files__description">
                {wcShared?.translate("Captures d'ecran ou autres (50 Mo maximum)")}
              </div>
              <div
                class={{
                  'mail-product-files__files': true,
                  'mail-product-files__files--hover': this.dragOverFiles,
                }}
                onDragOver={(event) => {
                  event.preventDefault();
                  this.dragOverFiles = true;
                }}
                onDragLeave={() => (this.dragOverFiles = false)}
                onDrop={(event) => {
                  this.dragOverFiles = false;
                  this.formatFiles(event);
                }}
              >
                {Boolean(Object.keys(this.files)[0]) ? (
                  <div class="file-container">
                    {[
                      this.files.map((file, index) => {
                        return (
                          <div class="file">
                            <div
                              class="file__close"
                              onClick={() => this.deleteFile(index)}
                            >
                              <img
                                src={getAssetPath('./../assets/icons/white-cross.svg')}
                                alt={wcShared.translate('Supprimer')}
                              />
                            </div>
                            <img
                              src={getAssetPath(
                                `./../assets/icons/mimetype/${this.getMimeType(file)}.svg`,
                              )}
                              alt={wcShared.translate('Fichier')}
                            />
                            <div class="tooltip">
                              <span class={{ tooltiptext: true }}>{file.name}</span>
                              <div class="file__title">{file.name}</div>
                            </div>
                          </div>
                        );
                      }),
                      <div
                        class="upload"
                        onClick={(event) => this.addFile(event)}
                      >
                        +
                      </div>,
                    ]}
                  </div>
                ) : (
                  <div class="file-container">
                    <img
                      src={getAssetPath('./../assets/icons/attachment_2.svg')}
                      alt={wcShared.translate('Icon attachment')}
                    />
                    <div>
                      <a
                        href="#"
                        onClick={(event) => this.addFile(event)}
                      >
                        {wcShared?.translate('Ajouter un fichier')}
                      </a>{' '}
                      {wcShared?.translate('ou faites glisser les fichiers ici')}
                    </div>
                  </div>
                )}
              </div>
              {/* Error Files */}
              <div class={{ error: true, hide: this.arrayError.length === 0 }}>
                {this.arrayError.map((file) => {
                  return (
                    <div
                      class="error-file"
                      innerHTML={wcShared?.translate(
                        '<strong>$name$</strong> est trop volumineux',
                        {
                          name: wcShared.store?.pipes?.escapeHtml(file.name),
                        },
                      )}
                    ></div>
                  );
                })}
              </div>
              <div class="mail-product-files__info">
                <img
                  src={getAssetPath('./../assets/icons/information.svg')}
                  alt={wcShared.translate('Icon information')}
                />
                <p>
                  {wcShared?.translate(
                    'Nos techniciens auront acces a la conversation afin de vous aider plus facilement',
                  )}
                </p>
              </div>
            </div>

            {/* Action */}
            <div class="mail-product-action">
              <button
                type="button"
                onClick={() => {
                  this.send();
                  this.checkEmptyField = true;
                }}
                class={{ disabled: !this.checkFields() && this.checkEmptyField }}
              >
                {wcShared?.translate('Envoyer ma demande')}
              </button>
            </div>
            <input
              class="hide"
              ref={(el) => {
                this.inputFile = el as HTMLInputElement;
              }}
              onChange={(event) => this.formatFiles(event)}
              type="file"
              multiple
              hidden
            />
          </div>
          <div
            class={{
              'mail-product--success': true,
              hide: !SectionStore?.get('section')?.contact_mail_success,
            }}
          >
            <contact-mail-success-module></contact-mail-success-module>
          </div>
          <div
            class={{
              'mail-product--error': true,
              hide: !SectionStore?.get('section')?.contact_mail_error,
            }}
          >
            <contact-mail-error-module></contact-mail-error-module>
          </div>
        </Host>
      );
    }
  }
}
